module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.ttf?38fec6307db2547752379b51322ded10";